import { render, staticRenderFns } from "./MakeFeed.vue?vue&type=template&id=e0d2a1b2&scoped=true&"
import script from "./MakeFeed.vue?vue&type=script&lang=js&"
export * from "./MakeFeed.vue?vue&type=script&lang=js&"
import style0 from "./MakeFeed.vue?vue&type=style&index=0&id=e0d2a1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d2a1b2",
  null
  
)

export default component.exports